module.exports = __webpack_public_path__ + "img/home.b830b6.svg";